import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { HiChevronRight } from 'react-icons/hi'
import { buildBreadcrumbs } from '../../config/settings/breadcrumbs'
import {
  Nav,
  List,
  Item,
  Separator,
  CrumbLink,
  CrumbCurrent,
} from './Breadcrumb.styles'

const Breadcrumb = () => {
  const location = useLocation()
  const { menus = [] } = useSelector((state) => state.acl)

  const crumbs = useMemo(
    () => buildBreadcrumbs(location.pathname, menus),
    [location.pathname, menus]
  )

  if (!crumbs.length) return null

  return (
    <Nav aria-label="Miga de pan">
      <List>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1

          return (
            <Item key={`${crumb.path}-${crumb.label}`}>
              {index > 0 && (
                <Separator aria-hidden="true">
                  <HiChevronRight size={14} />
                </Separator>
              )}
              {isLast || crumb.current ? (
                <CrumbCurrent aria-current="page">{crumb.label}</CrumbCurrent>
              ) : (
                <CrumbLink to={crumb.path}>{crumb.label}</CrumbLink>
              )}
            </Item>
          )
        })}
      </List>
    </Nav>
  )
}

export default Breadcrumb
